/**
 * Generated by orval v6.16.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useQuery, useMutation } from '@tanstack/react-query';
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey,
} from '@tanstack/react-query';
import type {
  GenericResponseAIFeedbackResponse,
  HTTPValidationError,
  AIFeedbackCreate,
  ErrorResponse,
  GenericResponseDict,
  GetVersionVersionGet200,
} from './models';
import { customInstance } from '../core/customInstance';
import type { ErrorType } from '../core/customInstance';

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

export const getGwAiFeedbackApiDocs = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>({ url: `/gw/ai-feedback-api/docs`, method: 'get', signal }, options);
};

export const getGetGwAiFeedbackApiDocsQueryKey = () => [`/gw/ai-feedback-api/docs`] as const;

export const getGetGwAiFeedbackApiDocsQueryOptions = <
  TData = Awaited<ReturnType<typeof getGwAiFeedbackApiDocs>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getGwAiFeedbackApiDocs>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryOptions<Awaited<ReturnType<typeof getGwAiFeedbackApiDocs>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGwAiFeedbackApiDocsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGwAiFeedbackApiDocs>>> = ({ signal }) =>
    getGwAiFeedbackApiDocs(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetGwAiFeedbackApiDocsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGwAiFeedbackApiDocs>>
>;
export type GetGwAiFeedbackApiDocsQueryError = ErrorType<unknown>;

export const useGetGwAiFeedbackApiDocs = <
  TData = Awaited<ReturnType<typeof getGwAiFeedbackApiDocs>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getGwAiFeedbackApiDocs>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetGwAiFeedbackApiDocsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Create new AI feedback
 * @summary Create Ai Feedback
 */
export const createAiFeedbackFeedbackPost = (
  aIFeedbackCreate: AIFeedbackCreate,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<GenericResponseAIFeedbackResponse>(
    {
      url: `/gw/ai-feedback-api/feedback`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: aIFeedbackCreate,
    },
    options,
  );
};

export const getCreateAiFeedbackFeedbackPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAiFeedbackFeedbackPost>>,
    TError,
    { data: AIFeedbackCreate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAiFeedbackFeedbackPost>>,
  TError,
  { data: AIFeedbackCreate },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAiFeedbackFeedbackPost>>,
    { data: AIFeedbackCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createAiFeedbackFeedbackPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAiFeedbackFeedbackPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAiFeedbackFeedbackPost>>
>;
export type CreateAiFeedbackFeedbackPostMutationBody = AIFeedbackCreate;
export type CreateAiFeedbackFeedbackPostMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Create Ai Feedback
 */
export const useCreateAiFeedbackFeedbackPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAiFeedbackFeedbackPost>>,
    TError,
    { data: AIFeedbackCreate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const mutationOptions = getCreateAiFeedbackFeedbackPostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get Live
 */
export const getLiveHealthLiveGet = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/gw/ai-feedback-api/health/live`, method: 'get', signal },
    options,
  );
};

export const getGetLiveHealthLiveGetQueryKey = () => [`/gw/ai-feedback-api/health/live`] as const;

export const getGetLiveHealthLiveGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getLiveHealthLiveGet>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getLiveHealthLiveGet>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryOptions<Awaited<ReturnType<typeof getLiveHealthLiveGet>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLiveHealthLiveGetQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLiveHealthLiveGet>>> = ({ signal }) =>
    getLiveHealthLiveGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetLiveHealthLiveGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLiveHealthLiveGet>>
>;
export type GetLiveHealthLiveGetQueryError = ErrorType<unknown>;

/**
 * @summary Get Live
 */
export const useGetLiveHealthLiveGet = <
  TData = Awaited<ReturnType<typeof getLiveHealthLiveGet>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getLiveHealthLiveGet>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetLiveHealthLiveGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Get Ready
 */
export const getReadyHealthReadyGet = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/gw/ai-feedback-api/health/ready`, method: 'get', signal },
    options,
  );
};

export const getGetReadyHealthReadyGetQueryKey = () =>
  [`/gw/ai-feedback-api/health/ready`] as const;

export const getGetReadyHealthReadyGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getReadyHealthReadyGet>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getReadyHealthReadyGet>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryOptions<Awaited<ReturnType<typeof getReadyHealthReadyGet>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReadyHealthReadyGetQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReadyHealthReadyGet>>> = ({ signal }) =>
    getReadyHealthReadyGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetReadyHealthReadyGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReadyHealthReadyGet>>
>;
export type GetReadyHealthReadyGetQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get Ready
 */
export const useGetReadyHealthReadyGet = <
  TData = Awaited<ReturnType<typeof getReadyHealthReadyGet>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getReadyHealthReadyGet>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetReadyHealthReadyGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Endpoint that serves Prometheus metrics.
 * @summary Metrics
 */
export const metricsMetricsGet = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    { url: `/gw/ai-feedback-api/metrics`, method: 'get', signal },
    options,
  );
};

export const getMetricsMetricsGetQueryKey = () => [`/gw/ai-feedback-api/metrics`] as const;

export const getMetricsMetricsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof metricsMetricsGet>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof metricsMetricsGet>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryOptions<Awaited<ReturnType<typeof metricsMetricsGet>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMetricsMetricsGetQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof metricsMetricsGet>>> = ({ signal }) =>
    metricsMetricsGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type MetricsMetricsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof metricsMetricsGet>>
>;
export type MetricsMetricsGetQueryError = ErrorType<unknown>;

/**
 * @summary Metrics
 */
export const useMetricsMetricsGet = <
  TData = Awaited<ReturnType<typeof metricsMetricsGet>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof metricsMetricsGet>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getMetricsMetricsGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getGwAiFeedbackApiOpenapiJson = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/gw/ai-feedback-api/openapi.json`, method: 'get', signal },
    options,
  );
};

export const getGetGwAiFeedbackApiOpenapiJsonQueryKey = () =>
  [`/gw/ai-feedback-api/openapi.json`] as const;

export const getGetGwAiFeedbackApiOpenapiJsonQueryOptions = <
  TData = Awaited<ReturnType<typeof getGwAiFeedbackApiOpenapiJson>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getGwAiFeedbackApiOpenapiJson>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryOptions<Awaited<ReturnType<typeof getGwAiFeedbackApiOpenapiJson>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGwAiFeedbackApiOpenapiJsonQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGwAiFeedbackApiOpenapiJson>>> = ({
    signal,
  }) => getGwAiFeedbackApiOpenapiJson(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetGwAiFeedbackApiOpenapiJsonQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGwAiFeedbackApiOpenapiJson>>
>;
export type GetGwAiFeedbackApiOpenapiJsonQueryError = ErrorType<unknown>;

export const useGetGwAiFeedbackApiOpenapiJson = <
  TData = Awaited<ReturnType<typeof getGwAiFeedbackApiOpenapiJson>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getGwAiFeedbackApiOpenapiJson>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetGwAiFeedbackApiOpenapiJsonQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Create new AI feedback via event publishing
 * @summary Create Ai Feedback V2
 */
export const createAiFeedbackV2V2FeedbackPost = (
  aIFeedbackCreate: AIFeedbackCreate,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<GenericResponseDict>(
    {
      url: `/gw/ai-feedback-api/v2/feedback`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: aIFeedbackCreate,
    },
    options,
  );
};

export const getCreateAiFeedbackV2V2FeedbackPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAiFeedbackV2V2FeedbackPost>>,
    TError,
    { data: AIFeedbackCreate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAiFeedbackV2V2FeedbackPost>>,
  TError,
  { data: AIFeedbackCreate },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAiFeedbackV2V2FeedbackPost>>,
    { data: AIFeedbackCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createAiFeedbackV2V2FeedbackPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAiFeedbackV2V2FeedbackPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAiFeedbackV2V2FeedbackPost>>
>;
export type CreateAiFeedbackV2V2FeedbackPostMutationBody = AIFeedbackCreate;
export type CreateAiFeedbackV2V2FeedbackPostMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Create Ai Feedback V2
 */
export const useCreateAiFeedbackV2V2FeedbackPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAiFeedbackV2V2FeedbackPost>>,
    TError,
    { data: AIFeedbackCreate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const mutationOptions = getCreateAiFeedbackV2V2FeedbackPostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get the current version of the API.
 * @summary Get Version
 */
export const getVersionVersionGet = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetVersionVersionGet200>(
    { url: `/gw/ai-feedback-api/version`, method: 'get', signal },
    options,
  );
};

export const getGetVersionVersionGetQueryKey = () => [`/gw/ai-feedback-api/version`] as const;

export const getGetVersionVersionGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getVersionVersionGet>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getVersionVersionGet>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryOptions<Awaited<ReturnType<typeof getVersionVersionGet>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVersionVersionGetQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVersionVersionGet>>> = ({ signal }) =>
    getVersionVersionGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetVersionVersionGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVersionVersionGet>>
>;
export type GetVersionVersionGetQueryError = ErrorType<unknown>;

/**
 * @summary Get Version
 */
export const useGetVersionVersionGet = <
  TData = Awaited<ReturnType<typeof getVersionVersionGet>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getVersionVersionGet>>, TError, TData>;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetVersionVersionGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
